import { render, staticRenderFns } from "./invadobay-property-card.vue?vue&type=template&id=eaf0b134&scoped=true"
import script from "./invadobay-property-card.vue?vue&type=script&lang=js"
export * from "./invadobay-property-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf0b134",
  null
  
)

export default component.exports